
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-1 -1)","stroke-width":"2","fill":"none","fill-rule":"evenodd","opacity":".823"}},[_c('circle',{attrs:{"cx":"7","cy":"7","r":"5"}}),_c('path',{attrs:{"opacity":".66","d":"M10.5 10.5L14 14"}})])])
          )
        }
      }
    